class s extends HTMLElement {
  constructor() {
    (super(),
      (this.handleClick = this.handleClick.bind(this)),
      (this.handleClickOutside = this.handleClickOutside.bind(this)),
      (this.openLabel = window.strings.products.facets.open_filter),
      (this.closeLabel = window.strings.products.facets.close_filter));
  }
  connectedCallback() {
    ((this.toggleTrigger = this.querySelector("[data-dropdown-toggle]")),
      (this.content = this.querySelector("[data-dropdown-content]")),
      !(!this.toggleTrigger || !this.content) &&
        (this.toggleTrigger.addEventListener("click", this.handleClick),
        document.addEventListener("click", this.handleClickOutside)));
  }
  disconnectedCallback() {
    (this.toggleTrigger &&
      this.toggleTrigger.removeEventListener("click", this.handleClick),
      document.removeEventListener("click", this.handleClickOutside));
  }
  handleClick(t) {
    (t.stopPropagation(), this.toggle(t));
  }
  handleClickOutside(t) {
    !this.contains(t.target) && this.dataset.active === "true" && this.close();
  }
  open(t) {
    var e, i;
    (this.setAttribute("data-active", "true"),
      (e = this.toggleTrigger) == null ||
        e.setAttribute("aria-expanded", "true"),
      (i = this.toggleTrigger) == null ||
        i.setAttribute("aria-label", this.closeLabel),
      this.closeSiblings(),
      !this.contains(t.target) &&
        this.dataset.active === "true" &&
        this.close());
  }
  close() {
    var t, e;
    (this.setAttribute("data-active", "false"),
      (t = this.toggleTrigger) == null ||
        t.setAttribute("aria-expanded", "false"),
      (e = this.toggleTrigger) == null ||
        e.setAttribute("aria-label", this.openLabel));
  }
  toggle(t) {
    this.dataset.active === "false" ? this.open(t) : this.close();
  }
  closeSiblings() {
    document
      .querySelectorAll('filter-dropdown[data-active="true"]')
      .forEach((e) => {
        e !== this && e.close();
      });
  }
}
const r = () => {
  customElements.get("filter-dropdown") ||
    customElements.define("filter-dropdown", s);
};
r();
export { r as default };
